'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _superagent = require('superagent');

var _superagent2 = _interopRequireDefault(_superagent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var methods = ['get', 'post', 'put', 'patch', 'del'];

var ApiClient = function () {
  function ApiClient(req) {
    var _this = this;

    (0, _classCallCheck3.default)(this, ApiClient);
    this.authToken = null;
    this.apiUrl = null;

    methods.forEach(function (method) {
      return _this[method] = function (path) {
        var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            params = _ref.params,
            data = _ref.data;

        return new _promise2.default(function (resolve, reject) {
          var request = _superagent2.default[method](_this.formatUrl(path));

          if (params) {
            request.query(params);
          }

          if (_this.authToken) {
            request.set({ 'Authorization': _this.authToken });
          }

          if (__SERVER__ && req.get('cookie')) {
            request.set('cookie', req.get('cookie'));
          }

          if (data) {
            request.send(data);
          }

          request.end(function (err) {
            var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
                body = _ref2.body;

            return err ? reject(body || err) : resolve(body);
          });
        });
      };
    });
  }

  (0, _createClass3.default)(ApiClient, [{
    key: 'setAuthToken',
    value: function setAuthToken(authToken) {
      this.authToken = authToken;
    }
  }, {
    key: 'setApiUrl',
    value: function setApiUrl(url) {
      this.apiUrl = url;
    }
  }, {
    key: 'formatUrl',
    value: function formatUrl(path) {
      var adjustedPath = path[0] !== '/' ? '/' + path : path;
      return this.apiUrl + adjustedPath;
    }
    /*
     * There's a V8 bug where, when using Babel, exporting classes with only
     * constructors sometimes fails. Until it's patched, this is a solution to
     * "ApiClient is not defined" from issue #14.
     * https://github.com/erikras/react-redux-universal-hot-example/issues/14
     *
     * Relevant Babel bug (but they claim it's V8): https://phabricator.babeljs.io/T2455
     *
     * Remove it at your own risk.
     */

  }, {
    key: 'empty',
    value: function empty() {}
  }]);
  return ApiClient;
}();

exports.default = ApiClient;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/helpers/ApiClient.js
// module id = 1211
// module chunks = 0